import { FC, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MasterContext } from '../../../../../shared/contexts';
import { Vendor } from '../../../../../shared/interfaces/get-vendors-service';
import { VendorCardComponent } from '../VendorCardRender';
import { VendorType, VendorTypeDescription } from '../../../../../shared/interfaces/enums/vendor-values-enum';

interface VendorCardProps {
  vendor: Vendor;
  loading?: boolean;
}

export const VendorCard: FC<VendorCardProps> = ({
  vendor,
  loading,
}) => {
  const navigate = useNavigate();
  const { branchList } = useContext(MasterContext);

  const {
    codigo,
    nombre,
    contacto,
    telefono,
    mail,
    domicilio,
    localidad,
    provincia,
    tipoProveedor
  } = vendor;

  const actions = useMemo(
    () => [
      
    ],
    [navigate]
  )

  const columnsDataVendor = useMemo(() => [
    {
      label: 'Nombre',
      value: nombre,
      isLikeTitle: true,
      valueInBold: true,
    },
    {
      label: 'Contacto',
      value: contacto,
    },
    {
      label: 'Teléfono',
      value: telefono,
    },
    {
      label: 'Mail',
      value: mail,
      valueInBold: true,
    },
    {
      label: 'Domicilio',
      value: domicilio,
    },
    {
      label: 'Localidad',
      value: localidad,
    },
    {
      label: 'Provincia',
      value: provincia,
    },
  ],
  [
    codigo,
    nombre,
    contacto,
    telefono,
    mail,
    domicilio,
    localidad,
    provincia
  ]
);


  return (
    <VendorCardComponent
      title={VendorTypeDescription[tipoProveedor as VendorType]}
      article={undefined}
      tags={undefined}
      actions={actions}
      loading={loading}
      columnsData={columnsDataVendor}
    />
  );
};
